var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState, useRef } from 'react';
import classnames from 'classnames';
import { useTranslate } from 'ra-core';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Fade from '@material-ui/core/Fade';
import LinearProgress from '@material-ui/core/LinearProgress';
import { useMarkdownContent } from '../documentation';
import { ApplicationDetailsOverviewEditor } from './ApplicationDetailsOverviewEditor';
import { MarkdownView } from '../ui';
export const ApplicationDetailsOverviewField = (_a) => {
    var { id, record, canEdit } = _a, rest = __rest(_a, ["id", "record", "canEdit"]);
    const classes = useStyles(rest);
    const translate = useTranslate();
    const markdownElementRef = useRef();
    const [isEditingOverview, setIsEditingOverview] = useState(false);
    const [isOverviewScrollBottom, setIsOverviewScrollBottom] = useState(false);
    const [{ data, loading }, handleUpdate] = useMarkdownContent({
        entityType: 'application',
        entityUuid: record.id,
        navtitle: 'overview',
    });
    const handleOverviewScroll = event => {
        const { target } = event;
        setIsOverviewScrollBottom(!(target.scrollHeight - target.scrollTop <=
            target.clientHeight + 20));
    };
    useEffect(() => {
        if (!data || data.markdown == null || data.markdown === '') {
            setIsOverviewScrollBottom(false);
            return;
        }
        setTimeout(() => {
            setIsOverviewScrollBottom(markdownElementRef.current.scrollHeight >
                markdownElementRef.current.clientHeight + 20);
        }, 100);
    }, [data]);
    useEffect(() => {
        handleToggleViewing();
    }, [data]);
    const handleToggleEditing = () => {
        setIsEditingOverview(true);
    };
    const handleToggleViewing = () => {
        setIsEditingOverview(false);
    };
    if (loading) {
        return (React.createElement(Fade, { in: true, style: {
                transitionDelay: '300ms',
            }, unmountOnExit: true },
            React.createElement(LinearProgress, null)));
    }
    return (React.createElement("div", { className: classes.overview },
        React.createElement("div", { className: classes.overviewMarkdown },
            React.createElement(MarkdownView, { id: id, ref: markdownElementRef, className: classes.markdown, onScroll: handleOverviewScroll, value: data && data.markdown != null && data.markdown !== ''
                    ? data.markdown
                    : translate('resources.applications.notifications.empty_overview') }),
            React.createElement("div", { className: classnames(classes.overviewScrollFadeColor, {
                    [classes.overviewScrollFade]: isOverviewScrollBottom,
                    [classes.hideOverviewScrollFade]: !isOverviewScrollBottom,
                }) })),
        canEdit ? (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { color: "primary", title: translate('resources.applications.notifications.edit_overview'), className: classes.editButton, onClick: handleToggleEditing },
                React.createElement(EditIcon, { className: classes.icon })),
            React.createElement(ApplicationDetailsOverviewEditor, { initialValue: data ? data.markdown : null, onCancel: handleToggleViewing, onSave: handleUpdate, open: isEditingOverview }))) : null));
};
const useStyles = makeStyles(theme => ({
    overview: {
        display: 'flex',
        alignItems: 'baseline',
        marginBottom: '-40px',
        width: '100%',
    },
    overviewMarkdown: {
        width: '100%',
        overflowWrap: 'anywhere',
    },
    markdown: {},
    editButton: {
        marginLeft: theme.spacing(),
    },
    overviewScrollFade: {
        position: 'relative',
        top: '-40px',
        height: '40px',
        width: `calc(100% - ${theme.spacing(2)})`,
    },
    hideOverviewScrollFade: {
        position: 'relative',
        top: '-40px',
        height: '40px',
        opacity: 0,
        transition: 'opacity 2s',
    },
    overviewScrollFadeColor: {
        pointerEvents: 'none',
        background: 'linear-gradient(to bottom, rgba(251, 251, 251, 0) 0%, rgba(251, 251, 251, 1) 100%)',
    },
    icon: {
        fontSize: '1rem',
    },
}), {
    name: 'Layer7ApplicationOverviewField',
});
//# sourceMappingURL=ApplicationDetailsOverviewField.js.map